import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import Cancel from './../../../../assets/icons/close.png'

function AddTagsToHomePage(props) {

    const [keyword, setKeyword] = useState(null)
  
 

    const handleKeyword = (event) => {
      setKeyword(event.target.value)
    }
  console.log(keyword)
    const onClickSave = () => {
     
     
    }
    //test end
  
    const handleClose = () => {
      props.onHandleAddItem(false)
    }
   

  return (
    <div>
    <React.Fragment>
      <Dialog
       fullWidth={true}
        maxWidth='sm'
        open={props.open}
        onClose={handleClose}
      >
        <Grid container>
          <Grid item xs={6}>
            <DialogTitle>Add Tag</DialogTitle>
          </Grid>
          <Grid item xs={6}>
            <DialogActions>
              <Button onClick={handleClose}>
                <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
              </Button>
            </DialogActions>
          </Grid>
        </Grid>
        <DialogContent style={{ backgroundColor: '#f3f0f3' }}>
          <div>
            <Grid container sx={{ padding: '0.5rem' }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: '2rem' }}>
                  Tag
                </Typography>
              </Grid>
              <Grid item xs={9}>
                
                <TextField
                  label="Name"
                  value={keyword}
                  onChange={handleKeyword}
                  fullWidth
                  margin="normal"
                  InputLabelProps={{ sx: { color: '#371B17' } }}
                />
              </Grid>
            </Grid>
            

            <Grid container sx={{ padding: '0.5rem' }}>
              <Grid item xs={8}></Grid>

              <Grid item xs={4}>
                <Button className="AddItemButtons" onClick={onClickSave}>
                  Save
                </Button>
              </Grid>
            </Grid>

            
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  </div>
  )
}

export default AddTagsToHomePage